import { render, staticRenderFns } from "./CameraComponent.vue?vue&type=template&id=355e37b7&scoped=true"
import script from "./CameraComponent.vue?vue&type=script&lang=js"
export * from "./CameraComponent.vue?vue&type=script&lang=js"
import style0 from "./CameraComponent.vue?vue&type=style&index=0&id=355e37b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355e37b7",
  null
  
)

export default component.exports